/* eslint-disable @next/next/no-img-element */
"use client";

import * as React from "react";
import {
    Box,
    Button,
    Card,
    CardContent,
    Stack,
    Typography,
} from "@mui/material";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import CtaButton from "../buttonWithArrow";


const BORDER = "#E3E6EB";


export default function CarInvestmentCard({
    title,
    image,
    roiLabel = "Expected Profit / Annual ROI - 110%",
    stats,
    price,
    period = "/Per Month",
    onEnquire,
    surfaceColor = "#f7f9fc", roiPercentage, FleetData, setSelectedVehicle, setVehicleInfo, vehicleInfo,
    contact, setContact, setOpenEnquire, selectedVehicle
}) {

    React.useEffect(() => {
        if (FleetData) {
            const data = FleetData

            const initialVehicleInfo = data.map(vehicle => ({
                id: vehicle?.id, // Use _id from the response as id
                title: vehicle?.title,
                initial: '',
                monthly: '',
                month: '',
                image: vehicle?.image
            }))

            const updatedVehicleInfo = initialVehicleInfo.map(vehicle => {
                const matchingApiResponse = data.find(
                    apiVehicle => apiVehicle._id === vehicle.id
                )
                if (matchingApiResponse) {
                    return { ...vehicle, name: matchingApiResponse.name }
                }
                return vehicle
            })

            setVehicleInfo(updatedVehicleInfo)
        }
    }, [FleetData])

    const handleEnquiryClick = (carName, regionType) => {
        // Log the car name to check if it's correct
        const matchingCar = vehicleInfo.find(item => item.title === carName)
        // Scroll to the form section
        console.log('Car matchingCar:', matchingCar) // Log the car name to check if it's correct

        setSelectedVehicle(matchingCar?.id)

        if (matchingCar && matchingCar !== undefined) {
            setContact(prevState => ({
                ...prevState,
                ['vehicle']: matchingCar?.title,
                ['initial']: matchingCar?.initial,
                ['monthly']: matchingCar?.monthly,
                ['month']: matchingCar?.month,
                ['regionType']: regionType
            }))

            setOpenEnquire(true)
            // document
            //   .getElementById("contactForm")
            //   .scrollIntoView({ behavior: "smooth" });

            // Set focus on the email input field
            // if (vehicleRef.current) {
            //   vehicleRef.current.focus();
            // }
        } else {
            alert(`Car "${carName}" not found in vehicleInfo array`)
        }
    }

    return (
        <Card
            elevation={0}
            sx={{
                height: "100%",
                borderRadius: 5,
                border: `1px solid ${BORDER}`,
                overflow: "visible",
                bgcolor: "#fff",
            }}
        >
            {/* Image header */}
            <Box sx={{ position: "relative", p: 1 }}>
                <Box
                    sx={{
                        position: "relative",
                        // height: 300,
                        height: 210,
                        borderRadius: 4,         // bigger, like your mock
                        overflow: "hidden",
                        // inner white stroke on top of the image
                        "&::after": {
                            content: '""',
                            position: "absolute",
                            inset: 0,
                            borderRadius: "inherit",
                            // boxShadow: "inset 0 0 0 2px #ffffff",
                            pointerEvents: "none",
                        },
                    }}
                >
                    <img src={`${process.env.IMAGE_BASE_URL}${image}`} alt={title} style={{ width: "100%" }} />

                    {/* ROI pill – anchor INSIDE the image box */}
                    <Box
                        sx={{
                            position: "absolute",
                            top: 12,
                            left: 14,
                            px: 2,
                            py: 1,
                            borderRadius: "9999px",
                            backgroundColor: "#fff",
                            color: "#289CA7", // Same teal from your image
                            fontWeight: 800,
                            fontSize: 12,
                            lineHeight: 1.3,
                            border: "1px solid #289CA7",
                            whiteSpace: "nowrap",
                        }}
                    >
                        {`Expected Profit / Annual ROI -${roiPercentage}`} {/* Ex: "Expected Profit / Annual ROI - 110%" */}
                    </Box>

                </Box>
            </Box>


            {/* Body */}
            <CardContent sx={{ pt: 0, pb: 2.5 }}>
                <Typography
                    variant="h6"
                    sx={{
                        fontWeight: 800,
                        textAlign: "center",
                        mt: 0.5,
                        mb: 1.5,
                    }}
                >
                    {title}
                </Typography>

                {/* Stats row */}
                <Stack
                    direction="row"
                    spacing={1.5}
                    sx={{ px: 1, justifyContent: "center" }}
                >
                    {stats.slice(0, 3).map((s, i) => (
                        <Box
                            key={i}
                            sx={{
                                flex: 1,
                                minWidth: 0,
                                bgcolor: "#F2F4F7",
                                borderRadius: 3,
                                textAlign: "center",
                                px: 1,
                                py: 1.5,
                            }}
                        >
                            <Typography
                                sx={{ color: "#6B7280", fontWeight: 600, fontSize: 12 }}
                            >
                                {s.label}
                            </Typography>
                            <Typography
                                sx={{ fontWeight: 900, fontSize: 16, lineHeight: 1.15, mt: 0.5 }}
                            >
                                {s.value}
                            </Typography>
                            <Typography
                                sx={{ fontWeight: 800, fontSize: 12, letterSpacing: 0.4 }}
                            >
                                {s.suffix || "AED"}
                            </Typography>
                        </Box>
                    ))}
                </Stack>
            </CardContent>

            {/* Ticket seam with notches + footer */}
            <Box
                sx={{
                    position: "relative",
                    borderTop: `1px solid ${BORDER}`,
                    pt: 2,
                    pb: 2.5,
                    // no horizontal padding here; move it to an inner wrapper
                    "&:before, &:after": {
                        content: '""',
                        position: "absolute",
                        top: -9.5,                // center the 18px circle on the 1px seam
                        width: 18,
                        height: 18,
                        borderRadius: "50%",
                        backgroundColor: surfaceColor, // page color for true "cutout"
                        boxShadow: `inset 0 0 0 1px ${surfaceColor}`,
                        pointerEvents: "none",
                    },
                    "&:before": { left: -9 },
                    "&:after": { right: -9 },
                }}
            >
                {/* inner content gets the horizontal padding */}
                <Box sx={{ px: 2.5 }}>
                    <Stack spacing={2} alignItems="center">
                        <Typography sx={{ fontWeight: 900, fontSize: 22, letterSpacing: 0.2 }}>
                            {price}{" "}
                            <Box component="span" sx={{ color: "#8d9096", fontWeight: 600 }}>
                                {period}
                            </Box>
                        </Typography>
                        <CtaButton label="Enquire Now" onClick={() => handleEnquiryClick(title, "")} />
                        {/* <CtaButton cta={{ label: "Enquire Now", href: "#" }} /> */}
                    </Stack>
                </Box>
            </Box>
        </Card>
    );
}
